export function getUrlParams(key) {
    const params = [];
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    urlParams.forEach((value, key) => {
        params[key] = value;
    });
    if( params['param'] ){
        let decryptParam = atob(params['param']);
        let p = decryptParam.split(/&/);
        let params2 = [];
        p.forEach((v,k) => {
            if(v=='') return;
            let key = v.split(/=/)[0];
            let value = v.split(/=/)[1];
            params2[key] = value;
        });
        return params2;
    }
    return params;  //開發用之後可鎖掉
}
/*****
* 判斷查價是否超出左右範圍
******/
function isDivOutOfViewport(div) {
    const rect = div.getBoundingClientRect();
    const isOutOfViewport = (
        //rect.top < 0 ||                           // 元素的頂部超出螢幕頂部
        rect.left < 0 ||                          // 元素的左側超出螢幕左側
        //rect.bottom > window.innerHeight ||       // 元素的底部超出螢幕底部
        rect.right > window.innerWidth            // 元素的右側超出螢幕右側
    );
    return isOutOfViewport;
}
export function showTip(lastData,period)
{
    if( lastData == undefined ) return;
    let contentId  = 'crosstip';
    let content = 'content';
    let window_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let max_width = 700;
    let tipHtml = '';
    if( window_width <= max_width  ){  
//        tipHtml = '<table id="crosstip_table"><tr>'
//        + '<td nowrap id="tdate"></td>'
//        + '<td nowrap ><span class="tip_title">開</span> <span id="open"></span></td>'
//        + '<td nowrap ><span class="tip_title">高</span> <span id="high"></span></td>'
//        + '<td nowrap ><span class="tip_title">量</span> <span id="volume"></span></td>'
//        + '</tr>'
//        + '<tr><td nowrap id="ttime"></td>'
//        + '<td nowrap><span class="tip_title">低</span> <span id="low"></span></td>'
//        + '<td nowrap><span class="tip_title">收</span> <span id="close"></span></td>'
//        + '<td nowrap><span class="tip_title">漲跌</span> <span id="updn"></span></td>'
//        + '</tr></table>';
        tipHtml = '<table id="crosstip_table"><tr>'
        + '<td nowrap id="tdate"></td>'
        + '<td nowrap ><span class="tip_title">開</span> <span id="open"></span></td>'
        + '<td nowrap ><span class="tip_title">高</span> <span id="high"></span></td>'
        + '</tr>'
        + '<tr><td nowrap id="ttime"></td>'
        + '<td nowrap><span class="tip_title">收</span> <span id="close"></span></td>'
        + '<td nowrap><span class="tip_title">低</span> <span id="low"></span></td>'
        + '</tr>'
        + '<tr><td></td>'
        + '<td nowrap colspan=2 ><span class="tip_title">量</span> <span id="volume"></span></td>'        
        + '</tr></table>';

    }else{
        tipHtml = "<span id='tdate' class='tip_val'></span><span id='ttime' class='tip_val'></span>"
        + "<span class='tip_title'>開</span><span class='tip_val' id='open'></span>"
        + "<span class='tip_title'>高</span><span class='tip_val' id='high'></span>"
        + "<span class='tip_title'>低</span><span class='tip_val' id='low'></span>"
        + "<span class='tip_title'>收</span><span class='tip_val' id='close'></span>"
        + "<span class='tip_title'>量</span><span class='tip_val' id='volume'></span>";
       // + "<span class='tip_title'>漲跌</span><span class='tip_val' id='updn'></span>";
    }
    //tipHtml = isgb2(tipHtml);
    let div = document.getElementById('title');
    let title_width = div.clientWidth;
	let exists = false;
	let hText;
    if( document.getElementById(contentId)){
		exists = true;
		hText = document.getElementById(contentId);
	}else {
		hText = document.createElement(content);
		hText.id = contentId;
        var Text = document.createTextNode(content);      // Create a text node
        hText.appendChild(Text);  
        hText.innerHTML = tipHtml;
	}
    let topp  = 1;
    let right = 1;
    let opacity = 1;
    if( (title_width + 300) > window_width ){
    //    topp  = 25;
    //    opacity = 0.8;
    }
	hText.style.display = 'block';
    if( window_width <= max_width ){ 
        //opacity = 0.8;
        hText.style.width= '60%';
        hText.style.position = 'absolute';
        hText.style.top = topp + 'px';
        hText.style.right= right + 'px';
        //if( (title_width + 200) > window_width ){
        //    hText.style.fontSize = "1.2rem";
        //}else{
            hText.style.fontSize = "1.6rem";
        //}
    }else{
        hText.style.position = 'relative';            
        hText.style.fontSize = "1.8rem";
    }
	hText.style.opacity = opacity;   //數值愈小愈透明    
	hText.style.zIndex = 2;
	if( !exists ){
        document.getElementById( "tip" ).appendChild(hText);
    }
    // 填入數值
    let date = new Date(lastData.time * 1000);
    let year = date.getUTCFullYear().toString().substr(2,4);
    let month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    let day = date.getUTCDate().toString().padStart(2, '0');
    let hh = date.getUTCHours().toString().padStart(2, '0');
    let mm = date.getUTCMinutes().toString().padStart(2, '0');
    let words,dateStr,timeStr;
    if( period ==1 ){
        if( window_width > max_width  ) words = [date.getUTCFullYear(),month, day];
        else words = [month, day];
        dateStr = words.join("/");
        words = [hh,mm];
        timeStr = words.join(":");
    }else{
        if( window_width > max_width  ) words = [date.getUTCFullYear(),month, day];
        else words = [month, day];        
        dateStr = words.join("/");
        timeStr = "";
        if( lastData.ltime ){
            let ltime = lastData.ltime.toString().padStart(6,'0');
            hh = ltime.substr(0,2);
            mm = ltime.substr(2,2);
            words = [hh,mm];
            timeStr = words.join(":");        
        }
    }
    document.getElementById('tdate').innerHTML = dateStr;
    document.getElementById('ttime').innerHTML = timeStr;
    document.getElementById('open').innerHTML = lastData.open;
    document.getElementById('high').innerHTML = lastData.high;
    document.getElementById('low').innerHTML = lastData.low;
    document.getElementById('close').innerHTML = lastData.close;
    document.getElementById('volume').innerHTML = lastData.uvol;
    //if( lastData.updn == 0 ){
    //    document.getElementById('updn').innerHTML = '--';
    //    document.getElementById('updn').classList.add("eq");        
    //}else if( lastData.updn > 0 ){
    //    //document.getElementById('updn').innerHTML = '<i class="fa fa-caret-up fa-lg"></i> ' + lastData.updn;
    //    document.getElementById('updn').innerHTML = '<span class="up_sign"></span> ' + lastData.updn;
    //    document.getElementById('updn').classList.remove("dn", "eq", "up");        
    //    document.getElementById('updn').classList.add("up");
    //}else{
    //    //document.getElementById('updn').innerHTML = '<i class="fa fa-caret-down fa-lg"></i> ' + (0-lastData.updn);
    //    document.getElementById('updn').innerHTML = '<span class="dn_sign"></span> ' + (0-lastData.updn);
    //    document.getElementById('updn').classList.remove("dn", "eq", "up");        
    //    document.getElementById('updn').classList.add("dn");
    //}
    //if( isDivOutOfViewport(document.getElementById('tip'))== true ){
    //    hText.style.fontSize = "1.6rem";
    //}
    
    if( window_width <= max_width  )
    {
        div = document.getElementById('crosstip');
        const tip_width = div.clientWidth;
        div = document.getElementById('title');
        title_width = div.clientWidth;
        const a = window_width - title_width - tip_width;
        const b = window_width - title_width;
        //if( a > 0 && b > 300 ) document.getElementById('crosstip_table').style.width = '300px';
    }
}
export function src_resize(chart,lastData,period) 
{
console.log("src_resize");
    document.getElementById('tip').innerHTML = "";
    showTip(lastData,period);

    let div,height,tot=0;
    let log='';
    div = document.getElementById('crosstip');
    if( div == null ) return;
    const crosstip_width = div.clientWidth;    
    const window_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const title_width = window_width - crosstip_width - 10; //10padding
    document.getElementById('title').style.width = title_width + "px";    
        
    div = document.getElementById('head');
    height = div.clientHeight;
    tot = tot + height;
    log += height + ",";

    //div = document.getElementById('tools');
    //height = div.clientHeight;
    //tot = tot + height;
    //log += height + ",";

    div = document.getElementById('bottom');
    height = div.clientHeight;
    tot = tot + height;    
    log += height + ",";

    let window_height = window.innerHeight
    || document.documentElement.clientHeight
    || document.body.clientHeight;
    let chart_height = window_height - tot - 6;

    div = document.getElementById('container');
    let chart_width = div.clientWidth;
    chart.applyOptions({ width: chart_width, height: chart_height});
}
export function showNoDataMessage() {
    const container = document.getElementById('container');
    const noDataMessage = document.getElementById('no-data-message');
    if (!noDataMessage) {
        const message = document.createElement('div');
        const divwidth = 110;
        const chartContainer = document.getElementById('container');
        const leftpos = chartContainer.clientWidth/2 - divwidth/2;
        message.id = 'no-data-message';
        message.textContent = '查無資料';
        message.style.position = 'absolute';
        message.style.width = divwidth + 'px';
        message.style.top = '26px';
        message.style.left = leftpos + 'px';
        message.style.backgroundColor = 'rgba(0, 114, 227, 0.8)';
        message.style.color = 'white';
        message.style.fontSize = '20px';
        message.style.padding = '5px 10px';
        message.style.borderRadius = '5px';
        message.style.zIndex = '1000';
        message.style.display = 'flex';
        message.style.alignItems = 'center';
        message.style.justifyContent = 'center';
        message.style.opacity = 0.8;   //數值愈小愈透明
        container.appendChild(message);
        window.setTimeout(hideNoDataMessage, 1000);        
    }
}
export function hideNoDataMessage() {
    const noDataMessage = document.getElementById('no-data-message');
    if (noDataMessage) {
        noDataMessage.remove();
    }
}
export function leadingNumbers(str) {
    const regex = new RegExp(`^\\d+`);
    const match = str.match(regex);
    return match ? match[0] : null;
}
/******
* 將歷史(target)和當日(source)資料合併
* 週,月=量需累計, 高低值要比對
*******/
export function mergeArrays(target,source,period=1,seriestype) {
    if( !source || Object.keys(source).length==0 ) return target;
    source.forEach(sourceObj => {
        const targetIndex = target.findIndex(targetObj => targetObj.time === sourceObj.time);    
        if (targetIndex !== -1) {  //-1沒有符合對象
            //target[targetIndex] = Object.assign(target[targetIndex], sourceObj);
            if( period == 3 || period == 4 ){
                if( seriestype == 'candle'){
                    if( sourceObj.high && target[targetIndex]['high'] < sourceObj.high ) target[targetIndex]['high']=sourceObj.high;
                    if( sourceObj.low  && target[targetIndex]['low'] > sourceObj.low ) target[targetIndex]['low']=sourceObj.low;
                    if( sourceObj.uvol ) target[targetIndex]['uvol'] += sourceObj.uvol;
                    if( sourceObj.ltime ) target[targetIndex]['ltime'] = sourceObj.ltime;
                }else if(seriestype == 'volume'){
                    if( sourceObj.value ) target[targetIndex]['value'] += sourceObj.value;
                }
            }
        } else {            
            target.push(sourceObj);
        }
    });
    return target;
}
export function showOverlay() {
    document.getElementById('no-data').style.display = 'none';
    document.getElementById('loading-overlay').style.display = 'flex';
}
export function hideOverlay() {
    document.getElementById('loading-overlay').style.display = 'none';
}
// 檢查是否有數據
export function updateNoDataMessage(data) {
    const noDataElement = document.getElementById('no-data');
    if (data.length === 0) {
        noDataElement.style.display = 'block'; // 顯示 "無資料" 提示
    } else {
        noDataElement.style.display = 'none'; // 隱藏提示
    }
}

//export function set_tooltip(chart,currSeries,volumeSeries){






//不能執行要取消, 移到index.js處理
/*
export function set_tooltip(chart){
    const container = document.getElementById('container');
    const toolTipWidth = 80;
    const toolTipHeight = 80;
    const toolTipMargin = 15;
    let toolTip;
	toolTip = document.createElement('div');
    toolTip.style = `width: 150px; height: 120px; position: absolute; display: none; padding: 8px; box-sizing: border-box; font-size: 12px; text-align: left; z-index: 1000; top: 12px; left: 12px; pointer-events: none; border: 1px solid; border-radius: 2px;font-family: -apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;`;
    toolTip.style.background = 'white';
    toolTip.style.color = 'black';
    toolTip.style.borderColor = '#2962FF';
    container.appendChild(toolTip);
    chart.subscribeCrosshairMove(param => {
        if (
            param.point === undefined ||
            !param.time ||
            param.point.x < 0 ||
            param.point.x > container.clientWidth ||
            param.point.y < 0 ||
            param.point.y > container.clientHeight
        ) {
            //toolTip.style.display = 'none';
        } else {
            //toolTip.style.display = 'block';    
        }
    });
  
}
*/
/*測試OK
    const container = document.getElementById('container');
    const toolTipWidth = 80;
    const toolTipHeight = 80;
    const toolTipMargin = 15;
    let toolTip;
	toolTip = document.createElement('div');
    toolTip.style = `width: 150px; height: 120px; position: absolute; display: none; padding: 8px; box-sizing: border-box; font-size: 12px; text-align: left; z-index: 1000; top: 12px; left: 12px; pointer-events: none; border: 1px solid; border-radius: 2px;font-family: -apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;`;
    toolTip.style.background = 'white';
    toolTip.style.color = 'black';
    toolTip.style.borderColor = '#2962FF';
    //if( !exists ) container.appendChild(toolTip);
    container.appendChild(toolTip);

const crosshairMoveHandler = (param) => {
            if (!param || !param.time || !param.seriesPrices.size) {
                toolTip.style.display = 'none';
                return;
            }

            const priceData = param.seriesPrices.get(currentSeries);
            if (!priceData) {
                toolTip.style.display = 'none';
                return;
            }
console.log("priceData",priceData,typeof priceData);
            if( typeof priceData == 'object' ){
                const { open, high, low, close } = priceData;
            }else{
                const price = priceData;
            }
            toolTip.style.display = 'block';
            toolTip.innerHTML = `
                Open: ${open}<br>
                High: ${high}<br>
                Low: ${low}<br>
                Close: ${close}
            `;
            toolTip.style.left = param.point.x + 'px';
            toolTip.style.top = param.point.y + 'px';
        };

        // 订阅 crosshair 移动事件
        chart.subscribeCrosshairMove(crosshairMoveHandler);
*/
        // 点击按钮后取消订阅
        //document.getElementById('removeHandler').addEventListener('click', () => {
        //    chart.unsubscribeCrosshairMove(crosshairMoveHandler);
        //    tooltip.style.display = 'none'; // 隐藏工具提示
        //    alert('Crosshair move handler removed');
        //});

/*測試OK 2
    const container = document.getElementById('container');
    const toolTipWidth = 80;
    const toolTipHeight = 80;
    const toolTipMargin = 15;
    let toolTip;
	toolTip = document.createElement('div');
    toolTip.style = `width: 150px; height: 120px; position: absolute; display: none; padding: 8px; box-sizing: border-box; font-size: 12px; text-align: left; z-index: 1000; top: 12px; left: 12px; pointer-events: none; border: 1px solid; border-radius: 2px;font-family: -apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;`;
    toolTip.style.background = 'black';
    toolTip.style.color = 'white';
    //toolTip.style.borderColor = '#2962FF';
    toolTip.style.borderColor = '#5B5B5B';
    container.appendChild(toolTip);

//    chart.unsubscribeCrosshairMove(crosshairMoveHandler);

    chart.subscribeCrosshairMove(param => {
        if (
            param.point === undefined ||
            !param.time ||
            param.point.x < 0 ||
            param.point.x > container.clientWidth ||
            param.point.y < 0 ||
            param.point.y > container.clientHeight
        ) {
            toolTip.style.display = 'none';
        } else {
            toolTip.style.display = 'block';    
            const date = new Date(param.time * 1000);
            const year = date.getUTCFullYear();
            const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
            const day = date.getUTCDate().toString().padStart(2, '0');
            const words = [year, month, day];
            const dateStr = words.join("-");
            const volume = param.seriesPrices.get(volumeSeries);
            const priceData = param.seriesPrices.get(currentSeries);
            if (!priceData) {
                toolTip.style.display = 'none';
                return;
            }
            let coordinate;
            if( typeof priceData == 'object' ){
                const { open, high, low, close } = priceData;
                coordinate = currentSeries.priceToCoordinate(close);
                toolTip.innerHTML = `
                    <table width=100% cellspacing=1>
                    <tr><td colspan=4 style='background:black;color:white;text-align:center;width:100%;'>${dateStr}</td></tr>                
                    <tr><td colspan=4 style="font-size: 24px; margin: 4px 0px; color: ${'white'};width:100%;text-align:center;">${close}</td></tr>
                    <tr style='background:#4F4F4F;font-size:14px;'><td style='text-align:center;'>開</td><td>${open}</td><td style='text-align:center;'>高</td><td> ${high}</td></tr>
                    <tr style='background:#4F4F4F;font-size:14px;'><td style='text-align:center;'>低</td><td> ${low}</td><td style='text-align:center;'>量</td><td> ${volume}</td></tr>
                    </table>
                `;

            }else{
                const price = priceData;
                coordinate = currentSeries.priceToCoordinate(price);
                toolTip.innerHTML = `
                    <div style='text-align:center;width:100%;'>${dateStr}</div>
                    <div style="font-size: 24px; margin: 4px 0px; color: ${'white'};width:100%;text-align:center;">${price}</div>
                    <div style="font-size: 20px; margin: 4px 0px; color: ${'white'};width:100%;text-align:center;">${volume}</td></tr>
                    </table>
                `;
            }
            

            let shiftedCoordinate = param.point.x - 50;
            if (coordinate === null) {
                return;
            }
            shiftedCoordinate = Math.max(
                0,
                Math.min(container.clientWidth - toolTipWidth, shiftedCoordinate)
            );
            const coordinateY =
                coordinate - toolTipHeight - toolTipMargin > 0
                    ? coordinate - toolTipHeight - toolTipMargin
                    : Math.max(
                        0,
                        Math.min(
                            container.clientHeight - toolTipHeight - toolTipMargin,
                            coordinate + toolTipMargin
                        )
                    );
            toolTip.style.left = shiftedCoordinate + 'px';
            toolTip.style.top = coordinateY + 'px';
        }
    });
*/

/*
    const formattedData = seriesData.get(interval).map(candle => {
        if (candle.open === candle.close) {
            // 設置平盤顏色，例如灰色
            return {
                ...candle,
                color: "#FFFFFF",          // 平盤蠟燭的顏色
                wickColor: '#FFFFFF',      // 平盤影線的顏色
                borderColor: '#FFFFFF',    // 平盤邊框顏色
            };
        }
        return candle; // 如果不是平盤，使用默認顏色
    });
    */
